module.exports = __webpack_public_path__ + "static/media/ME.bf529997.svg";